import { type CdkStep, CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { Component, output } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Dialog stepper component. */
@Component({
	selector: 'protctc-get-started-stepper',
	templateUrl: './get-started-stepper.component.html',
	styleUrls: ['./get-started-stepper.component.css'],
	providers: [{ provide: CdkStepper, useExisting: GetStartedStepperComponent }],
	imports: [CommonModule, CdkStepperModule],
})
export class GetStartedStepperComponent extends CdkStepper {
	/** Emit when stepper is complete. */
	public readonly complete = output();

	/** Text of the button to change steps. */
	protected get nextButtonText(): string {
		return this.isLastStep ? 'Got it!' : 'Next';
	}

	/** Check if current step is last. */
	private get isLastStep(): boolean {
		return this.selected === this.steps.last;
	}

	/**
	 * Handle 'click' of a 'Next step' button.
	 */
	protected onNextStepClick(): void {
		if (this.isLastStep) {
			this.complete.emit();
		} else {
			this.next();
		}
	}

	/**
	 * Handle 'click' of the 'step-header' element.
	 * @param step Step.
	 */
	protected onStepClick(step: CdkStep): void {
		if (step.completed && step !== this.selected) {
			step.select();
		}
	}
}
